import { cn } from '@mntn-dev/ui-utilities'
import {
  DataListItem,
  type DataListItemProps,
} from '../../../data-list/data-list-item.tsx'
import { useCardContext } from '../../use-card.ts'

export type CardDetailsItemProps = DataListItemProps

export const CardDetailsItem = ({
  className,
  children,
  ...props
}: CardDetailsItemProps) => {
  const { scale } = useCardContext()
  return (
    <DataListItem
      className={cn('gap-1', scale !== 'lg' && 'gap-0.5', className)}
      {...props}
    >
      {children}
    </DataListItem>
  )
}
